/**
 * Thin client for lights_out_gm session APIs (Option B).
 */
import { ARCADE, API_PATH_PROXY_ENABLED } from '../../../utils/config';
import { acquireGmLease, endGmSession, noteGmState } from '../gmLease';

/** Lease key for this game's shared GM (game_engines/gm_registry.py). */
export const GM_GAME_ID = 'lights_out';

export const LIGHTS_GM_BASE = API_PATH_PROXY_ENABLED
    ? (ARCADE.lights_out?.API_BASE || '')
    : '/lights';

async function parseJson(res) {
    const data = await res.json().catch(() => ({}));
    if (!res.ok) {
        const err = new Error(data.error || `Lights GM HTTP ${res.status}`);
        err.status = res.status;
        err.data = data;
        throw err;
    }
    return noteGmState(GM_GAME_ID, data);
}

export async function createLightsSession() {
    await acquireGmLease(GM_GAME_ID);
    const res = await fetch(`${LIGHTS_GM_BASE}/session/create`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: '{}',
    });
    return parseJson(res);
}

export async function moveLightsSession(sessionId, row, col) {
    const res = await fetch(`${LIGHTS_GM_BASE}/session/${sessionId}/move`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ row, col }),
    });
    return parseJson(res);
}

export async function deleteLightsSession(sessionId) {
    if (!sessionId) return;
    endGmSession(GM_GAME_ID, sessionId);
    try {
        await fetch(`${LIGHTS_GM_BASE}/session/${sessionId}/delete`, { method: 'POST' });
    } catch {
        /* best-effort */
    }
}

/** Scoring constants — kept for tests/docs; GM is authoritative at runtime. */
export const LIGHT_OFF_POINTS = 55;
export const SOLVE_BONUS = 400;
export const EFFICIENCY_POINTS_PER_MOVE = 10;
export const EFFICIENCY_MOVE_BUDGET = 80;
